import { Component } from '@angular/core';
import { CenterReveal } from '../../../directives/center-reveal';
import { BottomTransitionReveal } from '../../../directives/bottom-transition-reveal';
import { FadeInReveal } from '../../../directives/fade-in-reveal';

@Component({
  selector: 'app-about-me',
  imports: [
    CenterReveal,
    BottomTransitionReveal,
    FadeInReveal
  ],
  templateUrl: './about-me.html',
  styleUrl: './about-me.less'
})
export class AboutMe {

}
